import { Currencies } from '../constants';

import { PaymentDirections } from './payment-directions';
import { PaymentTypes } from './payment-types';

// Default
export interface PaymentMethod {
    id: number;
    name: string;
    currency: Currencies;
    direction: PaymentDirections;
    paymentType: PaymentTypes;
}
